import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=c290d80c&"
import script from "./CandidateList.vue?vue&type=script&lang=js&"
export * from "./CandidateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports